import {
    PayloadAction,
} from '@reduxjs/toolkit';

import {TTableReportRequestParameters, ITableReportSliceState} from '../table-report-slice-types';

export const createTableReportQueryParamsReducer = <S extends ITableReportSliceState>() => ({
    setTableReportQueryParams(state: S, {payload}: PayloadAction<{
        params: TTableReportRequestParameters | undefined;
        noFetch?: boolean;
    }>) {
        state.queryParameters.parameters = payload.params;
        state.reportOptions.noFetchWithParameters = !!payload.noFetch;
    },
    resetTableReportQueryParams(state: S, {payload}: PayloadAction<{noFetch?: boolean} | void>) {
        state.queryParameters.parameters = undefined;
        state.reportOptions.noFetchWithParameters = !!payload?.noFetch;
    },
});
